// extracted by mini-css-extract-plugin
export default {"footer__icon-author":"Footer_footer__icon-author__yv+u6"};